module.exports = __webpack_public_path__ + "static/media/portrait.e1b0aec3.svg";